/*
Thin re-export of the subset of `jose` that the UX uses.

Why a shim? PhantomJS — used as the karma browser — has no WebCrypto,
so we cannot exercise jose verification in the test environment. The
shim exports a single mutable object so tests can replace individual
methods (e.g. `jose.jwtVerify = sinon.stub()`) and have the override
seen by every importer.
*/

import * as jose from 'jose'

// Single mutable namespace. Importers must use `jose.X(...)` so the
// lookup happens at call time (allowing tests to replace methods).
const shim = {
  jwtVerify: jose.jwtVerify,
  decodeProtectedHeader: jose.decodeProtectedHeader,
  decodeJwt: jose.decodeJwt,
  createLocalJWKSet: jose.createLocalJWKSet,
  createRemoteJWKSet: jose.createRemoteJWKSet
}

export default shim



// WEBPACK FOOTER //
// ./src/lib/jose-shim.js